import { Component, Input } from '@angular/core';

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

  @Input() title: string;
  @Input() description: string;
  @Input() condensed = false;
  @Input() size: string;
}
